import React from 'react';
import Helmet from 'react-helmet';
import { PageContainer } from '../../components/Page';
import LawyerGroup from '../../components/LawyerGroup';
import { withRouteData } from 'react-static';
import DangerousHTML from '../../components/DangerousHTML';

export default withRouteData(({ content, lawyers }) => (<React.Fragment>
  <Helmet title={content ? content.title : ''} />
  <PageContainer>
    <LawyerGroup lawyers={lawyers} />
    <div className="row">
      <div className="col-md-offset-3 col-md-6 col-sm-offset-1 col-sm-10 page-content">
        <DangerousHTML html={content ? content.body : ''} />
      </div>
    </div>
  </PageContainer>
</React.Fragment>));
